<template>
  <div id="consulta">
    <Header :logged="logged" />
    <div class="slide-content-wrapper col-12">
      <div class="p-2 bd-highlight">
        <div id="contato" class="container">
          <b-card
            bg-variant="dark"
            text-variant="black"
            class="contato text-center mt-1"
            title="FAÇA SEU CONVÊNIO"
          >
          <p v-if="TextRecupere">Recupere seu crédito através dos cartórios de protesto de forma eletrônica, ágil e segura. <br>Para maiores informações preencha o formulário abaixo:</p>
            <b-card-text class="mt-2">
              <div class="row mt-2">
                <div class="col-md-12">
                  <b-alert
                    :show="mensagem_enviada"
                    variant="success"
                    class="text-center"
                  >Sua mensagem foi enviada. Responderemos em breve!</b-alert>
                  <b-alert
                    :show="!mensagem_enviada && mensagem_enviada!=null"
                    variant="danger"
                    class="text-center"
                  >Não foi possível completar a solicitação.</b-alert>
                  <div v-if="mensagem_enviada==null">
                    <form class="mt-3">
                      <b-card bg-variant="dark" text-variant="white" class="mt-3">
                        <b-card-text>
                          <b-row>
                            <b-col cols="12" md="12">
                              <b-input-group class="mb-3">
                                <b-input-group-prepend class="input"></b-input-group-prepend>
                                <b-form-input
                                  v-model="razaoSocial"
                                  id="razaoSocial"
                                  class="LoginInput"
                                  placeholder="Razão Social"
                                ></b-form-input>
                              </b-input-group>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" md="5">
                              <b-input-group class="mb-3">
                                <b-input-group-prepend></b-input-group-prepend>
                                <b-form-input
                                  v-model="cnpj"
                                  :formatter="mascaraDoc"
                                  @keypress="maxLenght($event,cnpj,14)"
                                  @blur="verificaCadastro"
                                  id="cnpj"
                                  class="LoginInput"
                                  placeholder="CNPJ"
                                  type="text"
                                ></b-form-input>
                                <p
                                  v-if="errocnpj"
                                  style="color:red;"
                                >&nbsp; CNPJ já solicitou o convênio</p>
                              </b-input-group>
                            </b-col>
                            <b-col cols="12" md="7">
                              <b-input-group class="mb-3">
                                <b-input-group-prepend></b-input-group-prepend>
                                <b-form-input
                                  v-model="nomeResponsavel"
                                  id="nomeResponsavel"
                                  class="LoginInput"
                                  placeholder="Nome do responsável"
                                ></b-form-input>
                              </b-input-group>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" md="6">
                              <b-input-group class="mb-3">
                                <b-input-group-prepend></b-input-group-prepend>
                                <b-form-input
                                  v-model="email"
                                  id="email"
                                  class="LoginInput"
                                  placeholder="E-mail"
                                ></b-form-input>
                              </b-input-group>
                            </b-col>
                          <b-col cols="12" md="6">
                            <b-input-group class="mb-3 rounded">
                              <b-input-group-prepend></b-input-group-prepend>
                              <the-mask
                                :mask="['(##) ####-####', '(##) #####-####']"
                                id="telefone"
                                v-model="telefone" @blur.native="validaTel"
                                placeholder="Telefone"
                                class="form-control"
                              />
                            </b-input-group>
                            <transition name="fade"> 
                              <b-alert :show="alertTel" fade variant="danger" class="text-center">Informe um telefone válido</b-alert>                                                                     
                              </transition>
                              <transition name="fade"> 
                              <b-alert :show="alert" fade variant="danger" class="text-center" v-html='alertMessage'>- Erro -</b-alert>                                                                                                     
                            </transition>
                          </b-col>
                          </b-row>
                          <b-row>
                          <b-col cols="12" md="6" >
                            <b-input-group class="mb-3 rounded">
                                <b-input-group-prepend></b-input-group-prepend>
                                <the-mask
                                  :mask="['(##) #####-####']"
                                  id="whatsapp"
                                  v-model="whatsapp" @blur.native="validaWhat"
                                  placeholder="WhatsApp"
                                  class="form-control"
                                />
                            </b-input-group>
                              <transition name="fade"> 
                                <b-alert :show="alertWhat" fade variant="danger" class="text-center">Informe um whatsapp válido</b-alert>                                                                     
                                </transition>
                                <transition name="fade"> 
                                <b-alert :show="alert" fade variant="danger" class="text-center" v-html='alertMessage'>- Erro -</b-alert>                                                                                                     
                              </transition>
                          </b-col>
                            <b-col cols="12" md="6">
                              <b-input-group class="mb-3 rounded">
                                <b-input-group-prepend></b-input-group-prepend>
                                <the-mask
                                  :mask="['(##) ####-####', '(##) #####-####']"
                                  id="celular"
                                  v-model="celular" @blur.native="validaCell"
                                  placeholder="Celular"
                                  class="form-control"
                                />
                              </b-input-group>
                              <transition name="fade"> 
                                <b-alert :show="alertCell" fade variant="danger" class="text-center">Informe um celular válido</b-alert>                                                                     
                                </transition>
                                <transition name="fade"> 
                                <b-alert :show="alert" fade variant="danger" class="text-center" v-html='alertMessage'>- Erro -</b-alert>                                                                                                     
                              </transition>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                              <b-input-group class="mb-3">
                                <b-input-group-prepend></b-input-group-prepend>
                                <b-form-input
                                  v-model="segmento"
                                  id="segmento"
                                  class="LoginInput"
                                  placeholder="Segmento"
                                ></b-form-input>
                              </b-input-group>
                            </b-col>
                          </b-row>
                        </b-card-text>
                      </b-card>

                      <b-card bg-variant="dark" text-variant="white" class="mt-3">
                        <b-card-text>
                          <b-form-group label="Informações dos Títulos:">
                            <b-form-checkbox-group
                              id="infoTitulo"
                              v-model="infoTitulo"
                              :options="infoTitulos"
                              name="infoTitulo"
                              :checked="infoTitulo.indexOf(infoTitulos.value) >= 0"
                            ></b-form-checkbox-group>
                          </b-form-group>

                          <b-input-group class="mb-3">
                            <b-input-group-prepend></b-input-group-prepend>
                            <b-form-select
                              v-model="expectativaMensal"
                              id="expectativaMensal"
                              class="LoginInput"
                              :options="expectativaMensais"
                            ></b-form-select>
                          </b-input-group>

                          <b-form-textarea
                            class="mb-3 LoginInput"
                            v-model="formaCobrança"
                            id="formaCobrança"
                            placeholder="Quais as formas de cobrança são utilizadas pela empresa para inadimplência? Já Utilizam o protesto?"
                            rows="5"
                            max-rows="6"
                          ></b-form-textarea>
                        </b-card-text>
                      </b-card>
                      <p> Agradecemos o seu contato, em breve retornaremos com as orientações para convênio.</p>
                      <b-row>
                        <b-col cols="8">
                      <b-button variant="outline-secondary float-left mt-3" @click="$router.push({ name: 'home' })"> Voltar</b-button>
                        </b-col>
                        <b-col cols="4">
                      <b-button class="btnMsg float-right mt-3" id="btn-continuar"  @click="enviar()">
                        <b-spinner id="loading-entrar" small type="grow" v-if="loading"></b-spinner>ENVIAR
                      </b-button>
                        </b-col>
                      </b-row>
                    </form>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
import Header from "../components/Header";
import Serv from "../services";
import API from "../services/api";

export default {
  components: {
    TheMask,
    Header
  },
  data() {
    return {
      TextRecupere: true,
      cd_convenio: "",
      infoTitulo: [],
      mensagem_enviada: null,
      razaoSocial: "",
      cnpj: "",
      nomeResponsavel: "",
      email: "",
      telefone: "",
      whatsapp: "",
      celular: "",
      segmento: "",
      formaCobrança: "",
      expectativaMensal: 0,
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 175,
        height: 175,
        class: "m1"
      },
      infoTitulos: [
        { value: 0, text: "DMI" },
        { value: 1, text: "DSI" },
        { value: 2, text: "NOTA PROMISSÓRIA" },
        { value: 3, text: "CBI" },
        { value: 4, text: "CONTRATOS" },
        { value: 5, text: "CHEQUE" },
        { value: 6, text: "OUTROS" }
      ],
      logged: "",
      loading: false,
      errocnpj: false,
      expectativaMensais: [
        { value: 0, text: "Expectativa mensal de títulos a enviar" },
        { value: 1, text: "De 0 a 99" },
        { value: 2, text: "De 100 a 500" },
        { value: 3, text: "De 501 a 999" },
        { value: 4, text: "Acima de 1000" }
      ],
      alertCell:false
    };
  },
  methods: {
    validar() {
      let self = this;
      let campos = [
        "razaoSocial",
        "cnpj",
        "nomeResponsavel",
        "email",
        "telefone",
        "whatsapp",
        "celular",
        "segmento",
        "infoTitulo",
        "formaCobrança",
        "expectativaMensal"
      ];
      let erros = 0;

      // verifica campos
      campos.forEach(campo => {
        erros += self.isInvalid(campo, self[campo]) ? 1 : 0;
      });

      const d = { ...this.$data };
      if (!Serv.validarEmail(d.email))
        document.getElementById("email").classList.add("is-invalid");
      //return false
      if (!Serv.validarCNPJ(this.cnpj))
        document.getElementById("cnpj").classList.add("is-invalid");
      if (!Serv.validarEmail(d.email) || !Serv.validarCNPJ(this.cnpj))
        return false;
      if (this.errocnpj) {
        document.getElementById("cnpj").classList.add("is-invalid");
        return false;
      }

      return erros > 0 ? false : true;
    },
    validaCell(){
      let self = this
      let bt = document.getElementById('btn-continuar')
      const regex = /^([0-9]{2})([9]{1})([0-9]{4})([0-9]{4})$/;
      const str = this.celular;
      // eslint-disable-next-line
      let m;
      //console.log(str)
      // eslint-disable-next-line
      if (m = regex.test(str)) {
        self.alertCell = false
        bt.disabled = false   
      }  else {
        self.alertCell = true
        bt.disabled = true        
      }   
    },
    validaTel(){
      let self = this
      let bt = document.getElementById('btn-continuar')
      const regexCell = /^([0-9]{2})([9]{1})([0-9]{4})([0-9]{4})$/;
      const regexTel =  /^([0-9]{2})([2-9]{1})([0-9]{3})([0-9]{4})$/;
      const str = this.telefone;
      // eslint-disable-next-line
      let m;
      //console.log(str)
      // eslint-disable-next-line
      if (m = regexCell.test(str) || regexTel.test(str)) {
        self.alertTel = false
        bt.disabled = false   
      }  else {
        self.alertTel = true
        bt.disabled = true        
      }   
    },
    validaWhat(){
      let self = this
      let bt = document.getElementById('btn-continuar')
      const regex = /^([0-9]{2})([9]{1})([0-9]{4})([0-9]{4})$/;
      const str = this.whatsapp;
      // eslint-disable-next-line
      let m;
      //console.log(str)
      // eslint-disable-next-line
      if (m = regex.test(str)) {
        self.alertWhat = false
        bt.disabled = false   
      }  else {
        self.alertWhat = true
        bt.disabled = true        
      }   
    },
    enviar() {
      let self = this;
      if (this.validar()) {
        const d = { ...this.$data };
        const dados = {
          razaoSocial: d.razaoSocial,
          cnpj: d.cnpj.replace(/\D/g, ""),
          nomeResponsavel: d.nomeResponsavel,
          email: d.email,
          telefone: d.telefone,
          whatsapp: d.whatsapp,
          celular: d.celular,
          segmento: d.segmento,
          formaCobrança: d.formaCobrança,
          expectativaMensal: d.expectativaMensal,
          infoTitulo: this.infoTitulo
        };
        this.loading = true;
        this.verificarCheckBox();

        API.post("convenio", dados).then(res => {
          if (res.data.enviada) {
            this.loading = false;
            this.TextRecupere = false;
            self.mensagem_enviada = true;
            
          } else {
            this.loading = false;
            self.mensagem_enviada = false;
          }
        });
      }
    },
    isInvalid(field, value) {
      if (!value) document.getElementById(field).classList.add("is-invalid");
      else document.getElementById(field).classList.remove("is-invalid");
      return value ? false : true;
    },
    verificarCheckBox() {
      var infoTitulo = document.getElementsByName("infoTitulo");

      for (var i = 0; i < infoTitulo.length; i++) {
        if (infoTitulo[i].checked == true) {
          return true;
        } else {
          return false;
        }
      }
    },
    mascaraDoc(value) {
      if (value == null) return "";
      else {
        let v = value;
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g, "");
        //Coloca ponto entre o segundo e o terceiro dígitos
        v = v.replace(/^(\d{2})(\d)/, "$1.$2");
        //Coloca ponto entre o quinto e o sexto dígitos
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
        //Coloca uma barra entre o oitavo e o nono dígitos
        v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
        //Coloca um hífen depois do bloco de quatro dígitos
        v = v.replace(/(\d{4})(\d)/, "$1-$2");

        return v;
        //}
      }
    },
    maxLenght(event, cnpj, limite) {
      let cnpjf = cnpj.replace(/\D/g, "");
      if (cnpjf.length > limite - 1) return event.preventDefault();
    },
    verificaCadastro() {
      this.loading = true;
      let self = this;
      if (this.cnpj.length > 0 && Serv.validarCNPJ(this.cnpj)) {
        API.get("convenio/verifdoc/" + this.cnpj.replace(/\D/g, "")).then(
          res => {
            if (res.data == 0) {
              document.getElementById("cnpj").classList.add("is-invalid");
              self.errocnpj = true;
            } else {
              self.errocnpj = false;
              document.getElementById("cnpj").classList.remove("is-invalid");
            }
          }
        );
      } else document.getElementById("cnpj").classList.add("is-invalid");
      this.loading = false;
    }
  }, //methods
  mounted() {
    this.$root
      .isLogged()
      .then(() => {
        this.logged = true;
      })
      .catch(() => {
        this.logged = false;
      });
  }
};
</script>

<style scoped>
h1 {
  font-size: 40px;
}
h1,
p,
p b {
  color: #000;
}
p {
  font-size: 17px;
}
p > b {
  margin-right: 15px;
}
.input {
  background-color: #ebf1fd;
  border-color: #2a6c9e;
}
.slide-content-wrapper {
  padding-top: 10%;
}
.btn-outline-secondary{
  font-size: 18px;
}
.LoginInput {
  background-color: #ddd;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #ced4da;
}
#contato {
  margin-top: 32px;
  font-family: "Kanit", sans-serif !important;
  font-size: 32px;
}
.bg-dark {
  background-color: #fff !important;
  border-color: #004e86;
}
.align {
  margin-top: 3%;
}
p {
  line-height: 2rem;
}
.home {
  margin-top: 4%;
}
.header {
  background-color: #f5f7f9;
  background-position: top;
  background-attachment: fixed;
  background-repeat: no-repeat;
  text-shadow: rgba(0, 0, 0, 0.6) 1px 1px 5px;
}
.btnMsg {
  background-color: #004e86;
  font-size: 18px;
  color: #fff;
}
.contato {
  color: #004e86;
  font-size: 32px;
}
.imgCirculo {
  margin-left: -224px;
}
.imgDigitando {
  margin-left: 40px;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  background-color: #ddd;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid#ced4da;
}
.mensagem {
  border: 1px solid#ced4da;
  background-color: #ddd;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.imgCel {
  margin-left: 21px;
}
#rodape {
  background-color: #eaecf5;
  width: 100%;
  height: 230px;
  position: absolute;
  z-index: 10;
  bottom: 0;
  margin-bottom: 0;
  color: #4c4c4c;
  font-size: 15px;
  font-family: "Kanit", sans-serif !important;
}
.mt-1,
.my-1 {
  margin-top: -5.75rem !important;
}
@media (min-width: 320px) and (max-width: 765px) {
  .mt-1{
    margin-top: 3.25rem !important;
}
}
</style>
